<template>
  <v-card class="mx-auto mt-8">
    <v-card-text>
      <div style="font-size:18px" class="mt-8">
        <b>Organization Name:</b>
        {{$store.getters.get_OrgDetails.org_name }}
      </div>
      <div style="font-size:20px" class="mt-8 mb-8">
        <b>Navigation:</b>
      </div>
      <div style="font-size:20px" class="mt-8 mb-8">
        <b>Display Id:</b>
        {{ $store.getters.get_OrgDetails.org_id }}
      </div>
      <div style="font-size:20px" class="mt-8 mb-8">
        <b>Survey Time Out(In Hours):</b>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  created() {
    console.log(this.$store.getters.get_OrgDetails);
  },
  data() {
    return {};
  },
  methods: {}
};
</script>